import { Root } from '@radix-ui/react-separator';

import { styled } from '../stitches.config';

export const Separator = styled(Root, {
  borderRadius: '99999px',
  '&[data-orientation=horizontal]': { height: 1, width: '100%' },
  '&[data-orientation=vertical]': { height: '100%', width: 1 },
});
